import { META_TAG_LOADING, META_TAG_ERROR, META_TAG_SUCCESS } from "./type";
const initState = { loading: true, error: false, metaTagListing: [] };
const metaTagReducer = (state = initState, action) => {
  switch (action.type) {
    case META_TAG_LOADING:
      return { ...state, loading: true };
    case META_TAG_ERROR:
      return { ...state, loading: false, error: true };
    case META_TAG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        metaTagListing: action.payload.metaTags,
        totalCount: action.payload.totalRecords,
      };
    default:
      return state;
  }
};

export { metaTagReducer };
